import React from 'react';
import Slider from '../../../Slider';
import subfolderSliderStyles from './SubfolderSlider.scss';
export var SubfolderSlider = function (_a) {
    var children = _a.children, disableArrows = _a.disableArrows;
    return (React.createElement("div", { className: subfolderSliderStyles['slider-wrapper'] },
        React.createElement(Slider, { className: subfolderSliderStyles['slider'], disableArrows: disableArrows }, children)));
};
SubfolderSlider.displayName = 'SubfolderSlider';
export default SubfolderSlider;
//# sourceMappingURL=SubfolderSlider.connected.js.map